var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useRef } from 'react';
import styled from 'styled-components';
import { Button, ButtonGroup, Paper, Tooltip, Typography } from '@material-ui/core';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import ArrowDropDownCircleOutlinedIcon from '@material-ui/icons/ArrowDropDownCircleOutlined';
import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined';
import { StateNodeType } from '@sierralabs/state-machine';
import { useFormContext } from '../FormContext';
import { useFormDragContext } from '../FormDragContext';
import { defaultSectionTitleRegExp } from '../FormSection.hooks';
import FormSection from './FormSection';
const StyledDiv = styled.div `
  position: relative;
  max-width: 768px;
  width: 100%;
  padding: 12px;
  margin: 0 auto;
  .section-label {
    display: flex;
    align-items: center;
    .final-icon {
      margin-right: 4px;
      width: 16px;
      height: 16px;
    }
  }
  .section-edit-menu {
    position: absolute;
    bottom: -4px;
    left: 50%;
    transform: translateX(-50%);
    .arrow-up {
      transform: rotate(180deg);
    }
  }
  &.selected .section-card {
    border-left: solid 4px ${props => props.theme.palette.primary.main};
    padding-left: 20px; /* account for border-left width */
  }
  .section-card {
    padding: 32px 24px;
  }
`;
export const FormSectionEditor = ({ index, stateNode }) => {
    var _a;
    const { formState, formSections, setFormState, addSection, moveSection } = useFormContext();
    const elementRef = useRef(null);
    const { dragSectionProps } = useFormDragContext();
    return (React.createElement(StyledDiv, { ref: elementRef, className: `form-section-editor${formState.selectedStateNode === stateNode ? ' selected' : ''}` },
        React.createElement(Typography, { variant: 'overline', className: 'section-label' },
            (stateNode === null || stateNode === void 0 ? void 0 : stateNode.type) === StateNodeType.Final && (React.createElement(RadioButtonCheckedIcon, { className: 'final-icon' })),
            "Section ",
            index + 1,
            " of ",
            formSections.length,
            ((_a = stateNode === null || stateNode === void 0 ? void 0 : stateNode.meta) === null || _a === void 0 ? void 0 : _a.title) &&
                !defaultSectionTitleRegExp.test(stateNode.meta.title) &&
                `: ${stateNode.meta.title}`),
        React.createElement(Paper, { className: 'section-card', onClick: () => {
                setFormState(Object.assign(Object.assign({}, formState), { selectedStateNode: stateNode, selectedFormElement: undefined }));
            } },
            React.createElement(FormSection, Object.assign({ edit: true, hasBack: index > 0, stateNode: stateNode }, dragSectionProps))),
        formState.selectedStateNode === stateNode && (React.createElement(ButtonGroup, { size: 'small', variant: 'contained', className: 'section-edit-menu', color: 'primary' },
            index > 0 && (React.createElement(Tooltip, { title: 'Move Section Up', placement: 'bottom', arrow: true },
                React.createElement(Button, { onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                        const destinationElement = elementRef.current.parentElement;
                        const sourceElement = destinationElement.previousElementSibling;
                        yield animateSwapElements(sourceElement, destinationElement);
                        moveSection(index, index - 1);
                    }) },
                    React.createElement(ArrowDropDownCircleOutlinedIcon, { className: 'arrow-up' })))),
            React.createElement(Tooltip, { title: 'Add Section', placement: 'bottom', arrow: true },
                React.createElement(Button, { onClick: () => addSection(index + 1) },
                    React.createElement(AddCircleOutlineOutlinedIcon, { className: 'add-section' }))),
            index < formSections.length - 1 && (React.createElement(Tooltip, { title: 'Move Section Down', placement: 'bottom', arrow: true },
                React.createElement(Button, { onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                        const sourceElement = elementRef.current.parentElement;
                        const destinationElement = sourceElement === null || sourceElement === void 0 ? void 0 : sourceElement.nextElementSibling;
                        yield animateSwapElements(sourceElement, destinationElement);
                        moveSection(index, index + 1);
                    }) },
                    React.createElement(ArrowDropDownCircleOutlinedIcon, { className: 'arrow-down' }))))))));
};
export default FormSectionEditor;
const animateSwapElements = (source, destination) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise(resolve => {
        if (!source || !destination) {
            return resolve({ source, destination });
        }
        source.setAttribute('style', `transition: transform 300ms; transform: translateY(${destination.clientHeight}px)`);
        destination === null || destination === void 0 ? void 0 : destination.setAttribute('style', `transition: transform 300ms; transform: translateY(${-source.clientHeight}px)`);
        const onTransitionEnd = () => {
            // destination.parentNode!.insertBefore(destination, source);
            source === null || source === void 0 ? void 0 : source.setAttribute('style', '');
            destination === null || destination === void 0 ? void 0 : destination.setAttribute('style', '');
            resolve({ source, destination });
            destination === null || destination === void 0 ? void 0 : destination.removeEventListener('transitionend', onTransitionEnd);
        };
        destination === null || destination === void 0 ? void 0 : destination.removeEventListener('transitionend', onTransitionEnd);
        destination === null || destination === void 0 ? void 0 : destination.addEventListener('transitionend', onTransitionEnd);
    });
});
//# sourceMappingURL=FormSectionEditor.js.map